import React from "react";
import Card from "../components/Card";
import TvKanalPaketCard from "../components/TvKanalPaketCard";

export default function TvPackages({ isVisible, network }) {
  return (
    <div className={isVisible ? "tel-pt-tv-packages" : "tel-pt-tv-packages not-visible"}>
      <p className="tel-pt-view-description">Vill du lägga till ytterligare kanalpaket?</p>

      {network.bredband &&
        network.tv_kanal_paket
          .filter((tvPackage) => tvPackage?.title !== "Baspaket")
          .map((tvPackage: any) => {
            if (tvPackage) return <TvKanalPaketCard data={tvPackage} />;

            return null;
          })}
      {!network.bredband && <h2 className="tel-p-form__no-product-text">Inga tillgängliga tv paket</h2>}
    </div>
  );
}
